import React, { Component } from 'react';
import './App.css';
import generateVisualization from './viz';

class App extends Component {
  constructor() {
    super();
    generateVisualization();
  }
  render() {
    return (
      <div className="App">
        <h2>Welcome to POUND Demo</h2>
        <strong><a href="https://davisshaver.com/2017/06/26/pound-hack-take-two-rebuilt-with-aws-services/#.1nK2Hq">Read more</a></strong>
        <div id="viz"></div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js